import React from 'react';
import { SEO } from '../components/SEO';
export function DatenschutzPage() {
  return <>
      <SEO title="Datenschutzerklärung - CRM Kraft | Justus Kraft" description="Datenschutzerklärung für CRM Kraft. Informationen über Datenerfassung, Verarbeitung und Ihre Rechte gemäß DSGVO." keywords="datenschutz, DSGVO, datenschutzerklärung, CRM Kraft, Justus Kraft" ogType="website" data-id="element-351" />
      <main className="pt-32 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-352">
        <div className="max-w-4xl mx-auto" data-id="element-353">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-white" data-id="element-354">
            Datenschutzerklärung
          </h1>

          <div className="prose prose-invert prose-lg max-w-none" data-id="element-355">
            <section className="mb-8" data-id="element-356">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-357">
                1. Datenschutz auf einen Blick
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-358">
                Allgemeine Hinweise
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-359">
                Die folgenden Hinweise geben einen einfachen Überblick darüber,
                was mit Ihren personenbezogenen Daten passiert, wenn Sie diese
                Website besuchen. Personenbezogene Daten sind alle Daten, mit
                denen Sie persönlich identifiziert werden können. Ausführliche
                Informationen zum Thema Datenschutz entnehmen Sie unserer unter
                diesem Text aufgeführten Datenschutzerklärung.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-360">
                Datenerfassung auf dieser Website
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-361">
                <strong className="text-white" data-id="element-362">
                  Wer ist verantwortlich für die Datenerfassung auf dieser
                  Website?
                </strong>
                <br data-id="element-363" />
                Die Datenverarbeitung auf dieser Website erfolgt durch den
                Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt
                „Hinweis zur verantwortlichen Stelle" in dieser
                Datenschutzerklärung entnehmen.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-364">
                <strong className="text-white" data-id="element-365">
                  Wie erfassen wir Ihre Daten?
                </strong>
                <br data-id="element-366" />
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
                mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie
                in ein Kontaktformular eingeben.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-367">
                Andere Daten werden automatisch oder nach Ihrer Einwilligung
                beim Besuch der Website durch unsere IT-Systeme erfasst. Das
                sind vor allem technische Daten (z. B. Internetbrowser,
                Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung
                dieser Daten erfolgt automatisch, sobald Sie diese Website
                betreten.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-368">
                <strong className="text-white" data-id="element-369">
                  Wofür nutzen wir Ihre Daten?
                </strong>
                <br data-id="element-370" />
                Ein Teil der Daten wird erhoben, um eine fehlerfreie
                Bereitstellung der Website zu gewährleisten. Andere Daten können
                zur Analyse Ihres Nutzerverhaltens verwendet werden.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-371">
                <strong className="text-white" data-id="element-372">
                  Welche Rechte haben Sie bezüglich Ihrer Daten?
                </strong>
                <br data-id="element-373" />
                Sie haben jederzeit das Recht, unentgeltlich Auskunft über
                Herkunft, Empfänger und Zweck Ihrer gespeicherten
                personenbezogenen Daten zu erhalten. Sie haben außerdem ein
                Recht, die Berichtigung oder Löschung dieser Daten zu verlangen.
                Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben,
                können Sie diese Einwilligung jederzeit für die Zukunft
                widerrufen. Außerdem haben Sie das Recht, unter bestimmten
                Umständen die Einschränkung der Verarbeitung Ihrer
                personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen
                ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-374">
                Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie
                sich jederzeit an uns wenden.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-375">
                Analyse-Tools und Tools von Drittanbietern
              </h3>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-376">
                Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch
                ausgewertet werden. Das geschieht vor allem mit sogenannten
                Analyseprogrammen.
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-377">
                Detaillierte Informationen zu diesen Analyseprogrammen finden
                Sie in der folgenden Datenschutzerklärung.
              </p>
            </section>

            <section className="mb-8" data-id="element-378">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-379">
                2. Hosting
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-380">
                Webflow
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-381">
                Wir hosten unsere Website bei Webflow. Anbieter ist die Webflow,
                Inc., 398 11th Street, 2nd Floor, San Francisco, CA 94103, USA
                (nachfolgend Webflow). Wenn Sie unsere Website besuchen, erfasst
                Webflow verschiedene Logfiles inklusive Ihrer IP-Adressen.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-382">
                Webflow ist ein Tool zum Erstellen und zum Hosten von Websites.
                Webflow speichert Cookies oder sonstige
                Wiedererkennungstechnologien, die für die Darstellung der Seite,
                zur Bereitstellung bestimmter Webseitenfunktionen und zur
                Gewährleistung der Sicherheit erforderlich sind (notwendige
                Cookies).
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-383">
                Details entnehmen Sie der Datenschutzerklärung von Webflow:{' '}
                <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#3B82F6] hover:text-[#60A5FA] transition-colors" data-id="element-384">
                  https://webflow.com/legal/eu-privacy-policy
                </a>
                .
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-385">
                Die Verwendung von Webflow erfolgt auf Grundlage von Art. 6 Abs.
                1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an einer
                möglichst zuverlässigen Darstellung unserer Website. Sofern eine
                entsprechende Einwilligung abgefragt wurde, erfolgt die
                Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit.
                a DSGVO und § 25 Abs. 1 TTDSG, soweit die Einwilligung die
                Speicherung von Cookies oder den Zugriff auf Informationen im
                Endgerät des Nutzers (z. B. Device-Fingerprinting) im Sinne des
                TTDSG umfasst. Die Einwilligung ist jederzeit widerrufbar.
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-386">
                Die Datenübertragung in die USA wird auf die
                Standardvertragsklauseln der EU-Kommission gestützt. Details
                finden Sie hier:{' '}
                <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#3B82F6] hover:text-[#60A5FA] transition-colors" data-id="element-387">
                  https://webflow.com/legal/eu-privacy-policy
                </a>
                .
              </p>
            </section>

            <section className="mb-8" data-id="element-388">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-389">
                3. Allgemeine Hinweise und Pflichtinformationen
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-390">
                Datenschutz
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-391">
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen
                Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
                vertraulich und entsprechend den gesetzlichen
                Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-392">
                Wenn Sie diese Website benutzen, werden verschiedene
                personenbezogene Daten erhoben. Personenbezogene Daten sind
                Daten, mit denen Sie persönlich identifiziert werden können. Die
                vorliegende Datenschutzerklärung erläutert, welche Daten wir
                erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu
                welchem Zweck das geschieht.
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-393">
                Wir weisen darauf hin, dass die Datenübertragung im Internet (z.
                B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen
                kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch
                Dritte ist nicht möglich.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-394">
                Hinweis zur verantwortlichen Stelle
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-395">
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser
                Website ist:
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-396">
                CRM Kraft LLC
                <br data-id="element-397" />
                Vertreten durch: Justus Kraft
                <br data-id="element-398" />
                7901 4th St. N, Ste. 300
                <br data-id="element-399" />
                St. Petersburg, FL 33702
                <br data-id="element-400" />
                United States of America
                <br data-id="element-401" />
                Telefon: +49 157 35999071
                <br data-id="element-402" />
                E-Mail: justus@crm-kraft.de
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-403">
                Verantwortliche Stelle ist die natürliche oder juristische
                Person, die allein oder gemeinsam mit anderen über die Zwecke
                und Mittel der Verarbeitung von personenbezogenen Daten (z. B.
                Namen, E-Mail-Adressen o. Ä.) entscheidet.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-404">
                Speicherdauer
              </h3>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-405">
                Soweit innerhalb dieser Datenschutzerklärung keine speziellere
                Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen
                Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt.
                Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine
                Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten
                gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe
                für die Speicherung Ihrer personenbezogenen Daten haben (z. B.
                steuer- oder handelsrechtliche Aufbewahrungsfristen); im
                letztgenannten Fall erfolgt die Löschung nach Fortfall dieser
                Gründe.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-406">
                SSL- bzw. TLS-Verschlüsselung
              </h3>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-407">
                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
                Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen
                oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine
                SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung
                erkennen Sie daran, dass die Adresszeile des Browsers von
                „http://" auf „https://" wechselt und an dem Schloss-Symbol in
                Ihrer Browserzeile.
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-408">
                Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die
                Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen
                werden.
              </p>
            </section>

            <section className="mb-8" data-id="element-409">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-410">
                4. Datenerfassung auf dieser Website
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-411">
                Cookies
              </h3>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-412">
                Unsere Internetseiten verwenden so genannte „Cookies". Cookies
                sind kleine Textdateien und richten auf Ihrem Endgerät keinen
                Schaden an. Sie werden entweder vorübergehend für die Dauer
                einer Sitzung (Session-Cookies) oder dauerhaft (permanente
                Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden
                nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies
                bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst
                löschen oder eine automatische Löschung durch Ihren Webbrowser
                erfolgt.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-413">
                Kontaktformular
              </h3>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-414">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen,
                werden Ihre Angaben aus dem Anfrageformular inklusive der von
                Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der
                Anfrage und für den Fall von Anschlussfragen bei uns
                gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung
                weiter.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-415">
                Anfrage per E-Mail, Telefon oder Telefax
              </h3>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-416">
                Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird
                Ihre Anfrage inklusive aller daraus hervorgehenden
                personenbezogenen Daten (Name, Anfrage) zum Zwecke der
                Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet.
                Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
            </section>

            <section className="mb-8" data-id="element-417">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-418">
                5. Plugins und Tools
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-419">
                YouTube
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-420">
                Diese Website bindet Videos der Website YouTube ein. Betreiber
                der Website ist die Google Ireland Limited („Google"), Gordon
                House, Barrow Street, Dublin 4, Irland.
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-421">
                Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in
                der Datenschutzerklärung von YouTube unter:{' '}
                <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer" className="text-[#3B82F6] hover:text-[#60A5FA] transition-colors" data-id="element-422">
                  https://policies.google.com/privacy?hl=de
                </a>
                .
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-423">
                Google Web Fonts
              </h3>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-424">
                Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten
                so genannte Web Fonts, die von Google bereitgestellt werden.
                Beim Aufruf einer Seite lädt Ihr Browser die benötigten Web
                Fonts in ihren Browsercache, um Texte und Schriftarten korrekt
                anzuzeigen.
              </p>
            </section>
          </div>
        </div>
      </main>
    </>;
}